const GYM_HISTORY_KEY = 'pushupProGymHistory';

export function getGymHistory() {
  try {
    const h = localStorage.getItem(GYM_HISTORY_KEY);
    return h ? JSON.parse(h) : [];
  } catch {
    return [];
  }
}

export function saveGymHistory(history) {
  try {
    localStorage.setItem(GYM_HISTORY_KEY, JSON.stringify(history));
  } catch (e) {
    // ignore
  }
}

export function getGymSession(date) {
  const history = getGymHistory();
  const entry = history.find(h => h.date === date);
  if (!entry) return {};

  // Parse session string "leg_curl:10,12|chest_press:8,8" into object
  const sessionData = {};
  if (entry.session) {
    entry.session.split('|').forEach(part => {
      if (part) {
        const [machine, repsStr] = part.split(':');
        if (machine && repsStr) {
          sessionData[machine] = repsStr.split(',').map(Number);
        }
      }
    });
  }
  return sessionData;
}

export function addGymSet(date, machine, reps) {
  const history = getGymHistory();
  let entryIndex = history.findIndex(h => h.date === date);

  let sessionData = {};
  if (entryIndex !== -1) {
    sessionData = getGymSession(date);
  } else {
    history.push({ date, session: '' });
    entryIndex = history.length - 1;
  }

  if (!sessionData[machine]) {
    sessionData[machine] = [];
  }
  sessionData[machine].push(reps);

  // Serialize session back to string
  const serializedSession = Object.keys(sessionData)
    .map(key => `${key}:${sessionData[key].join(',')}`)
    .join('|');

  history[entryIndex].session = serializedSession;
  saveGymHistory(history);
}

export function clearGymHistory() {
  localStorage.removeItem(GYM_HISTORY_KEY);
}
